import React from 'react'
import PropTypes from 'prop-types'
import { browserHistory } from 'react-router'

import Moment from 'moment'

import Styles from './index.scss'

const Item = (props) => {
  let status = 'No Sample Provided'
  if (props.row.portfolios && props.row.portfolios.count > 0) {
    let reviewCounter = 0
    let approveCounter = 0
    props.row.portfolios.rows.map((sample) => {
      if (props.row.status === props.statusList.rejected.value) {
        status = 'Rejected'
      }
      if (props.row.status === props.statusList.onReview.value) {
        status = 'Need Review'
        if (sample.portfolio.status === props.statusList.approved.value) {
          approveCounter += 1
        }
        if (sample.portfolio.status === props.statusList.onReview.value) {
          reviewCounter += 1
        }
        if (sample.portfolio.status === props.statusList.rejected.value && (
          approveCounter === 0 && reviewCounter === 0
        )) {
          status = 'No Sample Provided'
        }
      }
      if (props.row.status === props.statusList.approved.value) {
        status = 'No Sample Provided'
        if (sample.portfolio.status === props.statusList.rejected.value && (
          approveCounter === 0 && reviewCounter === 0
        )) {
          status = 'No Sample Provided'
        } else if (sample.portfolio.status === props.statusList.onReview.value) {
          approveCounter += 1
          status = 'Approved'
        } else {
          reviewCounter += 1
          status = 'Need Review'
        }
      }
      return status
    })
  }
  return (
    <tr
      onClick={props.isRowClickable ? () => {
        browserHistory.push(`/pending-products/${props.row.id}`)
      } : () => { }}
      style={{ cursor: 'pointer' }}
    >
      <td> {parseInt(props.skip, 0) + props.indexKey + 1} </td>
      <td>
        <button
          className={`${Styles['btn-view-marketplace']}`}
          onMouseEnter={props.setRowClickAble(false)}
          onMouseLeave={props.setRowClickAble(true)}
          onClick={props.goesTopPlatform(props.row.profile.profileId, props.userEmail, props.row.slug)}
        >
          <span>View as Super User</span>
        </button>
      </td>
      <td> <span>{props.row.statusLabel} </span></td>
      <td> {Moment(`${props.row.updatedAt}`).format('MMMM, DD YYYY')} </td>
      <td> {Moment(`${props.row.createdAt}`).format('MMMM, DD YYYY')} </td>
      <td> <span className="capitalize">{props.row.name} </span></td>
      <td>
        {/* <span> <Link to={`/profiles/${props.row.profile.profileId}`}>
          {props.row.profile.profileId}
        </Link> </span> */}
        <span>{props.row.profile.profileId}</span>
      </td>
      <td> <span>{props.row.profile.name} </span></td>
      <td> <span>{props.row.legacy ? 'Legacy' : 'Default'} </span></td>
      <td> <span>{props.row.country.name} </span></td>
      <td> <span>{props.row.productType.name} </span></td>
      <td> <span>{props.row.service.name} </span></td>
      <td> <span>{props.row.format.name} </span></td>
    </tr>
  )
}

Item.defaultProps = {
  row: {
    id: '',
    createdAt: '',
    updatedAt: '',
    name: '',
    profileId: '',
    url: '',
  },
  skip: 0,
  indexKey: 0,
  isRowClickable: false,
  setRowClickAble: () => { },
  productType: {
    name: '',
  },
  service: {
    name: '',
  },
  format: {
    name: '',
  },
  goesTopPlatform: () => { },
  userEmail: '',
}

Item.propTypes = {
  statusList: PropTypes.shape({
    onReview: PropTypes.shape({
      value: PropTypes.number.isRequired,
    }).isRequired,
    approved: PropTypes.shape({
      value: PropTypes.number.isRequired,
    }).isRequired,
    rejected: PropTypes.shape({
      value: PropTypes.number.isRequired,
    }).isRequired,
  }).isRequired,
  row: PropTypes.shape({
    id: PropTypes.string.isRequired,
    createdAt: PropTypes.string.isRequired,
    updatedAt: PropTypes.string,
    name: PropTypes.string.isRequired,
    portfolios: PropTypes.shape({
      count: PropTypes.number.isRequired,
      rows: PropTypes.arrayOf(PropTypes.object).isRequired,
    }),
    profile: PropTypes.shape({
      profileId: PropTypes.string.isRequired,
      name: PropTypes.string,
    }).isRequired,
    legacy: PropTypes.bool.isRequired,
    country: PropTypes.shape({
      name: PropTypes.string.isRequired,
    }).isRequired,
    productType: PropTypes.shape({
      name: PropTypes.string.isRequired,
    }).isRequired,
    service: PropTypes.shape({
      name: PropTypes.string.isRequired,
    }).isRequired,
    format: PropTypes.shape({
      name: PropTypes.string.isRequired,
    }).isRequired,
    statusLabel: PropTypes.string,
    slug: PropTypes.string.isRequired,
  }).isRequired,
  skip: PropTypes.number.isRequired,
  indexKey: PropTypes.number.isRequired,
  isRowClickable: PropTypes.bool,
  setRowClickAble: PropTypes.func,
  goesTopPlatform: PropTypes.func,
  userEmail: PropTypes.string,
}

export default Item
